import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import type { SeoIssue } from '@nucleus-commerce/api-client/admin';

const LINK = 'text-primary font-medium hover:underline';

/** Where to fix the issue: the entity's editor in this store, or the store settings. */
export function IssueEntityLink({ storeId, issue }: { storeId: string; issue: SeoIssue }) {
  const { t } = useTranslation('seo');
  const label = issue.handle ?? t(`entityType.${issue.entityType}`);

  switch (issue.entityType) {
    case 'store_product':
      return (
        <Link
          to="/s/$storeId/catalog/$storeProductId"
          params={{ storeId, storeProductId: issue.entityId }}
          className={LINK}
        >
          {label}
        </Link>
      );
    case 'collection':
      return (
        <Link
          to="/s/$storeId/collections/$collectionId"
          params={{ storeId, collectionId: issue.entityId }}
          className={LINK}
        >
          {label}
        </Link>
      );
    case 'page':
      return (
        <Link
          to="/s/$storeId/content/pages/$pageId"
          params={{ storeId, pageId: issue.entityId }}
          className={LINK}
        >
          {label}
        </Link>
      );
    case 'blog_post':
      return (
        <Link
          to="/s/$storeId/content/blog/$postId"
          params={{ storeId, postId: issue.entityId }}
          className={LINK}
        >
          {label}
        </Link>
      );
    case 'redirect':
      return (
        <Link
          to="/s/$storeId/content/redirects"
          params={{ storeId }}
          search={issue.handle ? { q: issue.handle } : {}}
          className={`${LINK} font-mono text-[13px]`}
        >
          {label}
        </Link>
      );
    case 'store':
      return (
        <Link to="/org/stores/$storeId" params={{ storeId }} className={LINK}>
          {t('entityType.store')}
        </Link>
      );
  }
}
